import { useUnit } from 'effector-react'
import { useStyles } from './styles'
import { $premiumLevel, $userBalance, $userLanguage, $userToken, PremiumLevel } from '@/entities/user'
import { lang } from '@/shared/constants/lang'
import { YourKeys } from '@/features/yourKeys'
import { PlatinumOffer } from '@/features/platinumOffer'
import { useEffect, useMemo } from 'react'
import { $specialOfferInfo, getSpecialOfferFx } from '@/entities/payments'
import { StarterPackShopFrame } from '@/pages/starterPackPage/ui/starterPackShopFrame'

export const ShopSales = () => {
  const { classes } = useStyles()
  const userLang = useUnit($userLanguage)
  const userSubscriptionLevel = useUnit($premiumLevel)
  const specialOffer = useUnit($specialOfferInfo)
  const userToken = useUnit($userToken)

  const balance = useUnit($userBalance)

  const showSpecialOffer = useMemo<boolean>(() => {
    return specialOffer !== null
  }, [specialOffer])

  const showPlatinumDiscount = useMemo(() => {
    const balanceCondition = balance >= 500_000
    const subLevelCondition = userSubscriptionLevel == PremiumLevel.UNSUBSCRIBED
    return balanceCondition && subLevelCondition
  }, [balance, userSubscriptionLevel])

  const showText = useMemo<boolean>(() => {
    return !showPlatinumDiscount && !showSpecialOffer
  }, [showPlatinumDiscount, showSpecialOffer])

  const texts = lang[userLang].pages.shop

  useEffect(() => {
    if (userToken && specialOffer === null) {
      getSpecialOfferFx(userToken)
    }
  }, [userToken, specialOffer])

  return (
    <div className={classes.root}>
      <span className={classes.heading}>{texts.shopHeading}</span>
      <YourKeys />
      <br />
      <div className={classes.offersContainer}>
        <span className={classes.subHeading}>{texts.specialOffers}</span>
        {specialOffer !== null && <StarterPackShopFrame {...specialOffer} />}
        {showPlatinumDiscount && <PlatinumOffer />}
        {showText && <p className={classes.nothingHere}>{texts.nothing}</p>}
      </div>
    </div>
  )
}
